import { SEARCH_STATUS } from '../../../utils/constants';
const Views = self => ({
    get isSearching() {
        return [SEARCH_STATUS.IDLE, SEARCH_STATUS.SEARCHING, SEARCH_STATUS.RETRYING_SEARCH].includes(self.searchStatus);
    },
});
export default Views;
